import React, { useState, useEffect } from "react";
import NavBar from "./components/General/navbar";
import Pages from "./components/General/pages";
import Content from "./components/General/content";

function App() {
  const [active, setActive] = React.useState("hero");
  const [isEdit, setEdit] = useState(false);
  return (
    <div className="app">
      <NavBar />
      <Content isEdit={isEdit} setEdit={setEdit} active={active} />
      <Pages
        isEdit={isEdit}
        setEdit={setEdit}
        active={active}
        setActive={setActive}
      />
    </div>
  );
}

export default App;
